export function hasInvoiceSystemComplianceProblem(
  isQualified: boolean | undefined,
  asQualified: boolean | undefined
): boolean {
  return (
    isQualified !== undefined &&
    asQualified !== undefined &&
    !isQualified &&
    !asQualified
  )
}
